import { IField } from '@esri/arcgis-rest-feature-service';
import { DomainCellRenderer } from '../components/GridComponents';

import CustomHeaderRenderer from '../components/GridComponents/Renderers/CustomHeaderRenderer';
import { esriTypeLookup } from '../consts/esriTypeInfo';
import { EsriTypeEditor } from '../components/GridComponents/Editors/EsriTypeEditor';
import { TextCellRenderer } from '../components/GridComponents/Renderers/TextCellRenderer';

export function fieldToColDef(
  field: IField,
  capabilities: LayerCapability[],
  frozen?: boolean,
  isAdmin?: boolean
): TypedColumn {
  const { type, formatter = TextCellRenderer } = esriTypeLookup[field.type];
  return {
    key: field.name,
    name: !field.alias || field.alias === '' ? field.name : field.alias,
    editable: (field.editable && capabilities.includes('Editing')) || isAdmin,
    resizable: true,

    // Calculate the width of the column based on the length of the field name
    width: field.name.length * 10 + 100 + 'px',

    renderHeaderCell: (props) => <CustomHeaderRenderer {...props} />,
    sortable: true,
    filterType: type,
    field,
    renderCell: field.domain?.codedValues ? DomainCellRenderer : formatter,
    frozen,

    renderEditCell: ({ column, row, onRowChange }) => (
      <EsriTypeEditor
        type={(column as unknown as TypedColumn).field.type}
        value={String(row[column.key])}
        onChange={(value) => onRowChange({ ...row, [column.key]: value })}
        domain={(column as unknown as TypedColumn).field.domain}
        autoEdit
      />
    ),
  } satisfies TypedColumn;
}
